export const EXCEPTION_BILLER_PAYEE_CODE = ['0023', '000500', '002500', '002200', '110000', '110100'];
export const EXCEPTION_BILLER_FULLNAME = ['PLN Pascabayar', 'PLN Postpaid'];
export const EXCEPTION_BILLER_VALUE = ['PLN Reload'];
export const EXCEPTION_FAVNAME = ['PLN Prepaid', 'PLN Prabayar', 'Indosat Ooredoo Paket Data'];
